import {useState, useCallback, useEffect} from 'react'

const storageName = 'userData'

export const useAuth = () => {
  const [token, setToken] = useState(null)
  const [ready, setReady] = useState(false)
  const [userId, setUserId] = useState(null)
  const [userTypeId, setUserTypeId] = useState(null)
  const [airportId, setAirportId] = useState(null)

  const login = useCallback((jwtToken, id, usertype_id, airport_id) => {
    setToken(jwtToken)
    setUserId(id)
    setUserTypeId(usertype_id)
    setAirportId(airport_id)

    localStorage.setItem(storageName, JSON.stringify({
      userId: id, 
      token: jwtToken,
      userTypeId: usertype_id,
      airportId: airport_id,
    }))
  }, [])


  const logout = useCallback(() => {
    setToken(null)
    setUserId(null)
    setUserTypeId(null)
    setAirportId(null)
    localStorage.removeItem(storageName)
  }, [])

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(storageName))

    if (data && data.token) {
      login(data.token, data.userId, data.userTypeId, data.airportId)
    }
    setReady(true)
  }, [login])


  return { login, logout, token, userId, userTypeId, airportId, ready }
}
